<app-input-select
  idField="id"
  labelField="parametro"
  [list]="parametri"
  [name]="name"
  label="Parametri"
  icon="science"
  [form]="form"
  [searchComponentTemplate]="searchTemplate"
></app-input-select>
